import React from 'react';

import SvgGuestRulesGRDogLeash from 'src/assets/svg/SvgGuestRulesGRDogLeash.svg';
import SvgGuestRulesGRDogPoopClean from 'src/assets/svg/SvgGuestRulesGRDogPoopClean.svg';
import SvgGuestRulesGRShieldCheck from 'src/assets/svg/SvgGuestRulesGRShieldCheck.svg';
import SvgGuestRulesGRTaskListPin from 'src/assets/svg/SvgGuestRulesGRTaskListPin.svg';
import SvgGuestRulesGRTimeClock from 'src/assets/svg/SvgGuestRulesGRTimeClock.svg';
import SvgGuestRulesGRToiletSign from 'src/assets/svg/SvgGuestRulesGRToiletSign.svg';
import SvgDogForbidden from 'src/assets/svg/SvgDogForbidden.svg';
import SvgPeopleHome from 'src/assets/svg/SvgPeopleHome.svg';
import SvgLockPassword from 'src/assets/svg/SvgLockPassword.svg';
import SvgThumbShine from 'src/assets/svg/SvgThumbShine.svg';
import SvgShieldWarning from 'src/assets/svg/SvgShieldWarning.svg';

export const HAS_REVIEWS = {
    NO: 'NO',
    HOST: 'HOST',
    GUEST: 'GUEST',
    BOTH: 'BOTH',
};

export const USER_TEST_GROUP = {
    ONE_PAGE_CHECKOUT: 'frontOnePageCheckout',
    APP_REQUIRED_SNIFFPASS: 'appRequiredSniffpass',
    GLOBAL_REQUIRED_SNIFFPASS: 'globalRequiredSniffpass',
    FRONT_SPECIFIC_TIME_FILTER: 'frontSpecificTimeFilterV6',
    FRONT_OPTIONAL_INTER_SNIFFPASS: 'frontOptionalInterSniffpassV2',
    FRONT_ENHANCED_REVIEW: 'frontEnhancedReview',
    FRONT_SNIFFPASS_HOMEPAGE: 'frontSniffpassHomepage',
    FRONT_NON_AUTH_REVIEW_V2: 'frontNonAuthReviewV2',
    FRONT_TWO_HOURS_WARN: 'frontTwoHoursWarn',
    FRONT_SPOT_LAST_ACTIVE: 'frontSpotLastActive',
    FRONT_SPOT_DETAIL_FAQS: 'frontSpotDetailFaqs',
    FRONT_SMALL_DOG_FENCING: 'frontSmallDogFencing',
    FRONT_RECENT_REVIEWS: 'frontRecentReviews',
    FRONT_SEARCH_60_MI: 'frontSearchSixtyMilesV3',
    BACK_SEARCH_LOC_DISTANCE: 'backSearchLocDistance',
    FRONT_AVAILABILITY_QUICK_FILTER: 'frontAvailabilityQuickFilterV2',
    FRONT_BRONZE_NO_DISC: 'frontBronzeNoDisc',
    FRONT_BRONZE_FIFTEEN: 'frontBronzeFifteen',
    FRONT_LOCATION_REQUEST: 'frontLocationRequest',
};

export const SIGN_UP_SRC = {
    ACCOUNT_WEB: 'ACCOUNT_WEB',
    AD_POPUP_WEB: 'AD_POPUP_WEB', // Ad popup
    ADD_PEOPLE_WEB: 'ADD_PEOPLE_WEB',
    BOTTOM_SEARCH_WEB: 'BOTTOM_SEARCH_WEB', // Bottom search
    CALENDAR_WEB: 'CALENDAR_WEB', // Calendar
    CHAT_WEB: 'CHAT_WEB',
    CHECKOUT_WEB: 'CHECKOUT_WEB', // Checkout
    CITY_DOG_PARK_WEB: 'CITY_DOG_PARK_WEB',
    DOGTRAINERS_WEB: 'DOGTRAINERS_WEB',
    FAVORITE_SEARCH_WEB: 'FAVORITE_SEARCH_WEB', // Favorite search
    FAVORITE_SPOT_WEB: 'FAVORITE_SPOT_WEB', // Favorite spot
    FILTERS_WEB: 'FILTERS_WEB',
    HOME_FORM_WEB: 'HOME_WEB',
    HOST_BANNER_WEB: 'HOST_BANNER_WEB', // Host banner
    HOST_CTA_WEB: 'HOST_CTA_WEB', // Host CTA
    HOST_FLOATING_CTA_WEB: 'HOST_FLOATING_CTA_WEB',
    HOST_LANDING_SHORT_WEB: 'HOST_LANDING_SHORT_WEB',
    INVITE_WEB: 'INVITE_WEB', // Invite
    MEMBERSHIPS_WEB: 'MEMBERSHIPS_WEB',
    MESSAGE_HOST_WEB: 'MESSAGE_HOST_WEB', // Message host
    NAV_WEB: 'NAVMENU_WEB', // Nav menu
    NEWHEADER_WEB: 'NEWHEADER_WEB', // New mobile top bar
    PHOTO_CAROUSEL_WEB: 'PHOTO_CAROUSEL_WEB',
    PHOTO_REQUEST_WEB: 'PHOTO_REQUEST_WEB', // Photo request
    REPORT_WEB: 'REPORT_WEB', // Report
    REVIEW_WEB: 'REVIEW_WEB',
    SEARCHPOPUP_WEB: 'SEARCHPOPUP_WEB',
    SEOPOPUP_SPOT_ALERT_WEB: 'SEOPOPUP_SPOT_ALERT_WEB',
    SEOPOPUP_WEB: 'SEOPOPUP_WEB',
    SNIFFPASS_WEB: 'SNIFFPASS_WEB',
    SNIFFPASS_HOME_WEB: 'SNIFFPASS_HOME_WEB',
    SPOT_DETAIL_SCROLL_WEB: 'SPOT_DETAIL_SCROLL_WEB',
    SPOT_DETAILS_WEB: 'SPOT_DETAILS_WEB',
    VISIT_WEB: 'VISIT_WEB',
};

export const GUEST_RULES_LIST = [
    {
        icon: <SvgGuestRulesGRDogLeash />,
        text: 'Dogs must be leashed when entering and exiting the spot.',
    },
    {
        icon: <SvgGuestRulesGRShieldCheck />,
        text: 'Make sure the area is safe before bringing your dog in.',
    },
    {
        icon: <SvgGuestRulesGRTimeClock />,
        text: 'Never enter a spot before your booking start time and never leave late.',
    },
    {
        icon: <SvgGuestRulesGRDogPoopClean />,
        text: 'Pick up after your dogs. Leave the spot as it was when you arrived.',
    },
    {
        icon: <SvgGuestRulesGRTaskListPin />,
        text: 'Always review and abide by spot specific rules.',
    },
    {
        icon: <SvgGuestRulesGRToiletSign />,
        text: 'Unless otherwise stated, restrooms are not available on site.',
    },
];

export const HOST_RULES_LIST = [
    {
        icon: <SvgShieldWarning />,
        text: 'Never meet guest dogs unless you confirm with the guest in advance.',
    },
    {
        icon: <SvgDogForbidden />,
        text: 'If you have dogs, make sure they are kept securely away from the spot.',
    },
    {
        icon: <SvgPeopleHome />,
        text: 'Make sure everyone on the property is aware of the visit, so they don’t let dogs out or enter the spot during the visit.',
    },
    {
        icon: <SvgThumbShine />,
        text: 'Try to keep your spot reasonably clean and free of hazards.',
    },
    {
        icon: <SvgLockPassword />,
        text: 'Make sure any gates are unlocked and guests can easily access your spot.',
    },
];
